export default __webpack_public_path__ + "images/onboarding-slide-2.3643149016f22d4db0b14703460e18c3.svg";